module.exports = __webpack_public_path__ + "static/media/houselogo.2bea2ebe.jpg";